import axios from '../../../utilities/axios';

export const acceptEtkRequest = async (): Promise<void> => {
  try {
    const response = await axios.post<void>(
      `${process.env.REACT_APP_BASE_URL}/users/me/etk`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
